module.exports = __webpack_public_path__ + "static/media/VectorPhone.59174cc4.svg";